export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB

export const MAX_FILE_SIZE_MB = 50;

export const isFileSizeValid = (file: File): boolean => {
  return file.size <= MAX_FILE_SIZE_BYTES;
};

export const isFileSizeBytesValid = (fileSizeBytes: number): boolean => {
  return fileSizeBytes <= MAX_FILE_SIZE_BYTES;
};

export const getFileSizeInMB = (file: File): number => {
  return parseFloat((file.size / (1024 * 1024)).toFixed(2));
};

export const bytesToMB = (bytes: number): number => {
  return parseFloat((bytes / (1024 * 1024)).toFixed(2));
};

export const validateFileSize = (file: File): string | null => {
  if (!isFileSizeValid(file)) {
    const fileSizeMB = getFileSizeInMB(file);
    return `File size (${fileSizeMB} MB) exceeds the maximum allowed size of ${MAX_FILE_SIZE_MB} MB`;
  }
  return null;
};

export const validateMultipleFileSizes = (files: File[]): string[] => {
  const errors: string[] = [];

  files.forEach((file, index) => {
    const error = validateFileSize(file);
    if (error) {
      errors.push(`File ${index + 1} (${file.name}): ${error}`);
    }
  });

  return errors;
};
